module.exports = __webpack_public_path__ + "img/pc.6d03288c.jpg";